import {
  BarChartOutlined,
  DatabaseOutlined,
  PictureOutlined,
  ProfileOutlined,
  RocketOutlined,
} from '@ant-design/icons';
import React from 'react';

export default {
  path: '/cloud-studio',
  name: '算力广场',
  code: 'CloudStudio',
  component: './CloudStudio/layout',
  routes: [
    { path: '/cloud-studio', hideInMenu: true, component: './MenuRedirect' },
    {
      path: '/cloud-studio/intro',
      hideInMenu: true,
      component: './CloudStudio/ProductIntro',
    },
    {
      path: '/cloud-studio/activation',
      hideInMenu: true,
      component: './CloudStudio/Activation',
    },
    {
      path: '/cloud-studio/marketplace',
      code: 'CloudStudio-Marketplace',
      name: '算力广场',
      icon: <RocketOutlined />,
      component: './CloudStudio/Marketplace',
    },
    {
      path: '/cloud-studio/marketplace/rent',
      hideInMenu: true,
      name: '立即租用',
      // code: 'CloudStudio-Marketplace-Rent-Button',
      component: './CloudStudio/Marketplace/Rent',
    },
    {
      path: '/cloud-studio/instances',
      code: 'CloudStudio-Instances',
      name: '实例管理',
      icon: <ProfileOutlined />,
      component: './CloudStudio/Instances',
    },
    {
      path: '/cloud-studio/instances/detail/:id',
      hideInMenu: true,
      name: '实例详情',
      component: './CloudStudio/Instances/Detail',
    },
    {
      path: '/cloud-studio/images',
      code: 'CloudStudio-Images',
      name: '自定义镜像',
      icon: <PictureOutlined />,
      component: './CloudStudio/Images',
    },
    {
      path: '/cloud-studio/storage',
      code: 'CloudStudio-Storage',
      name: '存储管理',
      icon: <DatabaseOutlined />,
      component: './CloudStudio/Storage',
    },
    {
      path: '/cloud-studio/usage-records',
      code: 'CloudStudio-UsageRecords',
      name: '使用记录',
      icon: <BarChartOutlined />,
      component: './CloudStudio/UsageRecords',
    },
  ],
};
